import Axios from 'axios'
import { getPathName, getApiHash, getApiToken } from './helper';

const obtenerBancos = async () => {
    const params = {
        hash: await getApiHash(),
    }
    const headers = {
        "Authorization": 'Bearer ' + await getApiToken()
    }
    return await Axios.post(await getPathName() + "/getBancosJSON", params,{headers: headers})
            .then(function (response) {
            return response.data.bancos;
        }).catch(function (error) {
            return error;
        });
};

export default obtenerBancos;